import { compose, map, propOr } from 'ramda';
import { dotPath } from 'ramda-extension';

/**
 * TODO: Remove this hack. Wb::Service error codes should to be extracted from
 * inside wb-apollo-error. Clients should have no knowledge of what error paths
 * like `extensions.exception.response.data.error.code` stands for.
 */
const extractErrorCode = dotPath(
  'extensions.exception.response.data.error.code'
);

/**
 * Flatten a GraphQL response object into a list of error codes.
 *
 * @param {object} graphQLResponse - A graphql response object.
 * @returns {Array<string>} The error codes.
 */
export const flattenGraphQLErrorCodes = compose(
  map(extractErrorCode),
  propOr([], 'graphQLErrors')
);
